import * as React from 'react';

function Refresh(props) {
	return (
		<svg
			aria-label={`refresh icon`}
			xmlns={'http://www.w3.org/2000/svg'}
			fill={'none'}
			viewBox={'0 0 16 16'}
			width={'16'}
			height={'16'}
			{...props}
		>
			<title>refresh icon</title>
			<path
				d={'M2.35147 2.35C3.80238 0.9 5.79362 0 8.005 0C12.4278 0 16 3.58 16 8C16 12.42 12.4278 16 8.005 16C4.27267 16 1.16073 13.45 0.270169 10H2.35147C3.17198 12.33 5.39337 14 8.005 14C11.3171 14 14.0088 11.31 14.0088 8C14.0088 4.69 11.3171 2 8.005 2C6.34397 2 4.86304 2.69 3.78236 3.78L7.00438 7H9.53674e-07V0L2.35147 2.35Z'}
				fill={'#757575'}
			/>
		</svg>
	);
}

export default Refresh;
